import { i18nStringType } from "i18n/i18nString";

export const TICKET_STATUS = {
  BEFORE_OPENING: "settlementHistory.ticketStatus.beforeOpening",
  ON_GOING: "settlementHistory.ticketStatus.ongoing",
  ENDED: "settlementHistory.ticketStatus.ended",
} as const satisfies Record<string, i18nStringType>;
